import Modal from 'react-bootstrap/Modal';
import { Delete } from "@mui/icons-material"
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material"
import { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx';

export const AddRaterModal = ({show, setShow, formik, currSubject, currSubjectIndex, ...rest}) => {
    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorGroup, setErrorGroup] = useState('');
    const [errorNoOfRaterGroup, setErrorNoOfRaterGroup] = useState('');
    const handleClose = () => setShow(false);

    useEffect(() => {
        // console.log("formik.values", formik.values)
        checkRaters()
        formik.setFieldValue('raterFirstName', '');
        formik.setFieldValue('raterLastName', '');
        formik.setFieldValue('raterEmail', '');
        formik.setFieldValue('raterGroup', null);
    },[show])

    const checkRatersOLD = () => {
        let errorMsg = ''
        if(formik.values.subjects[currSubjectIndex]?.subject_raters){
            let raters = formik.values.subjects[currSubjectIndex].subject_raters;
            let groups = {}
            for(let rater of raters){
                if(groups[rater.raterGroup.name]){
                    groups[rater.raterGroup.name] = groups[rater.raterGroup.name] + 1
                }
                else{
                    groups[rater.raterGroup.name] = 1
                }
            }
            console.log("groups-------------------------", groups)
            let isManagerAdded = false
            let managers = {}

            let raterGroups = formik.values.raterGroups;
            for(let raterGroup of raterGroups){
                if(raterGroup.name.toLowerCase().includes('manager')){
                    managers[raterGroup.name] = 0
                }
            }

            // console.log("managers", managers)

            for(let key of Object.keys(groups)){
                if(key.toLowerCase().includes('manager')){
                    managers[key] = groups[key]
                }
                // if(key.toLowerCase().includes('manager')){
                //     isManagerAdded = true
                // }
                if(groups[key] < 3 && !key.toLowerCase().includes('manager')){
                    let left = 3 - groups[key]
                    if(errorMsg === ''){
                        errorMsg = 'Please add '
                    }
                    errorMsg += left+' more '+key.toLowerCase()+', '
                }
            }
            for(let manager of Object.keys(managers)){
                console.log(manager)
                if(managers[manager] < 1){
                    if(errorMsg === ''){
                        errorMsg = 'Please add '
                    }    
                    errorMsg += ' 1 '+manager+', '
                }
            }
            // errorMsg.replace(/,\s*$/, "")
            // if(!isManagerAdded){
            //     if(errorMsg === ''){
            //         errorMsg = 'Please add '
            //     }    
            //     errorMsg += ' 1 manager'
            // }
            setErrorNoOfRaterGroup(errorMsg.replace(/,\s*$/, ""))
        }        
        
    }

    const checkRaters = () => {

        let errorMsg = '';

        if(formik.values.subjects[currSubjectIndex]?.subject_raters){

            let raters = formik.values.subjects[currSubjectIndex].subject_raters;

            let groups = {};

            for(let rater of raters){

                let groupName = rater.raterGroup.name;

                if(groups[groupName]){
                    groups[groupName] = groups[groupName] + 1
                }
                else{
                    groups[groupName] = 1
                }
            }

            let raterGroups = formik.values.raterGroups;

            for(let raterGroup of raterGroups){

                // only validate groups where min_one_rater = 1
                if(raterGroup.min_one_rater == 1){

                    let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0;

                    if(count < 1){

                        if(errorMsg === ''){
                            errorMsg = 'Please add ';
                        }

                        errorMsg += '1 ' + raterGroup.name + ', ';
                    }
                }
                else{
                    let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0

                    if(count < 3){
                        if(errorMsg === ''){
                            errorMsg = 'Please add ';
                        }

                        let left = 3 - count

                        errorMsg += left + ' ' + raterGroup.name + ', ';
                    }

                    
                }
            }

            setErrorNoOfRaterGroup(errorMsg.replace(/,\s*$/, ""));
        }
    }
    
    const checkRatersViaApi = async (raterArray) => {
        try {
            const result = await axios.post(`api/groups/findRaterInGroup`, {
                assessmentId: currSubject.assessmentId,
                rater: raterArray
            });
            if (result?.data?.success) {
                return result.data;
            } else {
                Swal.fire(result.data.message, '', 'error')
                return result.data.message;
            }
        } catch (error) {
            Swal.fire(error.response.data.message, '', 'error');
            return false; 
        }
    }

    const normalizeString = (value) => {
        if (!value) return '';
        return value.trim().replace(/\s+/g, ' ');
    };

    const addRater = async () => {

        const raterFirstName = normalizeString(formik.values.raterFirstName);
        const raterLastName = normalizeString(formik.values.raterLastName);

        if(raterFirstName === ''){
            setErrorFirstName('First Name is required')
        }
        if(raterLastName === ''){
            setErrorLastName('Last Name is required')
        }
        if(formik.values.raterEmail === ''){
            setErrorEmail('Email is required')
        }
        if(formik.values.raterGroup === null){
            setErrorGroup('Group is required')
        }
        if(raterFirstName !== '' && raterLastName !== '' && formik.values.raterEmail !== '' && formik.values.raterEmail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) && formik.values.raterGroup !== null){
            if(formik.values.subjects[currSubjectIndex]?.subject_raters){
                formik.values.subjects[currSubjectIndex].subject_raters = [...formik.values.subjects[currSubjectIndex].subject_raters, {
                    id: null,
                    firstName: raterFirstName,
                    lastName: raterLastName,
                    email: formik.values.raterEmail,
                    raterGroup: formik.values.raterGroup,
                }]
            }
            else{
                formik.values.subjects[currSubjectIndex].subject_raters = [{
                    id: null,
                    firstName: raterFirstName,
                    lastName: raterLastName,
                    email: formik.values.raterEmail,
                    raterGroup: formik.values.raterGroup,
                }]
            }
            formik.setFieldValue('raterFirstName', '');
            formik.setFieldValue('raterLastName', '');
            formik.setFieldValue('raterEmail', '');
            formik.setFieldValue('raterGroup', null); 
            checkRaters()   
        }     
           
    }

    const addRaterByFileUpload = async (rows) => {
        if (!rows || !Array.isArray(rows) || rows.length === 0) {
            console.error("Invalid or empty rows");
            return;
        }
        await Promise.all(rows.map((row, index) => {
            // console.log("FirstName:", row.FirstName);            
            if(row.FirstName !== '' && row.LastName !== '' && row.Email !== '' && row.Email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) && row.Group !== null){
                if(formik.values.subjects[currSubjectIndex]?.subject_raters){
                    formik.values.subjects[currSubjectIndex].subject_raters = [...formik.values.subjects[currSubjectIndex].subject_raters, {
                        id: null,
                        firstName: row.FirstName,
                        lastName: row.LastName,
                        email: row.Email,
                        raterGroup: row.Group,
                    }]
                }
                else{
                    formik.values.subjects[currSubjectIndex].subject_raters = [{
                        id: null,
                        firstName: row.FirstName,
                        lastName: row.LastName,
                        email: row.Email,
                        raterGroup: row.Group,
                    }]
                }
            }
        }));        
        checkRaters();    
           
    }

    const removeRater = (index) => {
        let updatedList = formik.values.subjects[currSubjectIndex].subject_raters;
        updatedList.splice(index, 1);
        formik.values.subjects[currSubjectIndex].subject_raters = updatedList
        formik.setFieldValue("subjects", formik.values.subjects)
    };

    const handleFirstNameChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('raterFirstName', value);
        setErrorFirstName('')
    }

    const handleLastNameChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('raterLastName', value);
        setErrorLastName('')
    }

    const handleEmailChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('raterEmail', value);
        setErrorEmail('')
    }

    const handleEmailBlur = (e) => {
        let value = e.target.value
        formik.setFieldValue('raterEmail', value);
        if(value === ''){
            setErrorEmail('')
        }
        else if(value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)){
            setErrorEmail('')
        }
        else{
            setErrorEmail('Enter valid email')
        }
    }

    const handleGroupChange = (e, value) => {
        if(value && value.id){
            formik.setFieldValue('raterGroup', value);            
        }
        else{
            formik.setFieldValue('raterGroup', null);
        }
        setErrorGroup('')
    }

    const onFileUpload = async (file) => { 
        if(file){
            console.log("=onFileUpload========>");
            const reader = new FileReader();
            reader.onload = async (event) => {
                const wb = XLSX.read(event.target.result);
                const sheets = wb.SheetNames;
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                    if (sheets.length) {
                        const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheets[0]]);                        
                        console.log('row===>',rows);      
                        const column1Values = rows.map(row => row['FirstName']);
                        const column2Values = rows.map(row => row['LastName']);
                        const column3Values = rows.map(row => row['Email']);
                        const column4Values = rows.map(row => row['Group']);
                        const hasEmptyFname = column1Values.some(fname => !fname || fname.trim() === '');
                        if (hasEmptyFname) {
                            Swal.fire("First name contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyLname = column2Values.some(lname => !lname || lname.trim() === '');
                        if (hasEmptyLname) {
                            Swal.fire("Last name contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyEmail = column3Values.some(email => !email || email.trim() === '');
                        if (hasEmptyEmail) {
                            Swal.fire("Email contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyGroup = column4Values.some(group => !group || group.trim() === '');                        
                        if (hasEmptyGroup) {
                            Swal.fire("Group contain empty values.", '', 'error');
                            return;
                        }             
                        // console.log('Column 4 Values', column4Values);
                        const uniqueColumn4Val = [...new Set(column4Values)];
                        const checkResult = await checkRatersViaApi(uniqueColumn4Val);                        
                        // console.log("checkResult===>", checkResult);
                        if (checkResult && checkResult.success && checkResult.data) {
                            let raterData = checkResult.data;
                            const mergedRows = rows.map(row => ({
                                ...row,
                                Group: raterData.find(group => group.name === row.Group) || row.Group // Find matching group or fallback
                            }));
                            // console.log("mergedRows===>", mergedRows);
                            await addRaterByFileUpload(mergedRows);
                            formik.setFieldValue("subjects", formik.values.subjects)
                            Swal.fire("Success", '', 'success');
                        }else{
                            Swal.fire("Failed "+checkResult, '', 'error');
                        }  
                          
                    
                    }
                } else {
                    Swal.fire('Must be Upload excel file', '', 'error');
                }
            }
            reader.readAsArrayBuffer(file);
        }
        
    };

    return (
        <Modal size="xl" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add Raters ({currSubject.firstName+' '+currSubject.lastName})</Modal.Title>
            </Modal.Header>
            <Modal.Body>                                               
            <div className="row">
                <div className="col-md-12">
                    {/* <h3 className="heading fs_20">Add Rater</h3> */}
                    {/* <div className="alert alert-warning" role="alert">
                        <b>Required no. of raters are 1 for Manager and 3 for all other rater groups.</b>
                    </div> */}
                    <div className="alert alert-warning" role="alert">
                        <b>Groups marked with minimum rater requirement must have at least 1 rater.</b>
                    </div>
                    <div className="row d-flex align-items-center mb-3">
                        <div className="col">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">First Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input type="text" name="raterFirstName" className="form-control" id="basic-icon-default-name" placeholder="First Name" aria-label="First Name" aria-describedby="basic-icon-default-fullname2" onChange={handleFirstNameChange} onBlur={handleFirstNameChange} value={formik.values.raterFirstName}/>
                                </div>
                                <div className="text-danger">{errorFirstName}&nbsp;</div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">Last Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input type="text" name="raterLastName" className="form-control" id="basic-icon-default-name" placeholder="Last Name" aria-label="Last Name" aria-describedby="basic-icon-default-fullname2" onChange={handleLastNameChange} onBlur={handleLastNameChange} value={formik.values.raterLastName}/>
                                </div>
                                <div className="text-danger">{errorLastName}&nbsp;</div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-email">Rater Email</label>
                                <div className="input-group input-group-merge">
                                    <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                    <input type="email" name="raterEmail" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" onChange={handleEmailChange} onBlur={handleEmailBlur} value={formik.values.raterEmail}/>
                                </div>
                                <div className="text-danger">{errorEmail}&nbsp;</div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-phone">Rater Group</label>   
                                <Autocomplete
                                    id="raterGroupId"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={formik.values.raterGroups}
                                    getOptionLabel={(option) => option.name}
                                    onChange={handleGroupChange}
                                    value={formik.values.raterGroup}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => <TextField {...params} label={"Rater Group"} />}
                                />
                                <div className="text-danger">{errorGroup}&nbsp;</div>
                            </div>
                        </div>
                        <div className="col-md-2 text-end">
                            <button type="button" className="btn w-100 btn-primary mb-2" onClick={addRater}>Add</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8"></div>
                        <div className="col-2 text-end"><a href={`${process.env.REACT_APP_BASE_URL}assets/DemoFile.xlsx`} target="_blank" download={true}  className="btn w-100 btn-primary mb-2">Download Sample</a></div>
                        <div className="col-2 text-end mb-3">
                            <input 
                                type="file" 
                                className="account-file-input" 
                                id="fileUpload" 
                                name='fileUpload'
                                style={{ display: "none" }}
                                aria-describedby="file-upload-help" 
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                onChange={(e) => {
                                    onFileUpload(e.target.files[0]);
                                    e.target.value = ""; 
                                }}
                            />
                            <label
                                htmlFor="fileUpload"
                                className="btn w-100 btn-primary"                               
                            >
                                Upload Raters
                            </label>
                            
                        </div>                        

                    </div>
                </div>
                <div className='col-md-12'>
                    {
                        errorNoOfRaterGroup !== '' ? 
                        <div className="alert alert-danger" role="alert">
                            <b>{errorNoOfRaterGroup}</b>
                        </div>
                        : ''
                    }
                </div>
                <div className="col-md-12">
                    <div className="row">
                        <table className="table table-striped mb-0">
                            <thead>
                                <tr>
                                <th scope="col">S. No.</th>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                                <th scope="col">Rater Email</th>
                                <th scope="col">Rater Group</th>
                                <th scope="col">Action</th>                                                
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.subjects[currSubjectIndex]?.subject_raters && formik.values.subjects[currSubjectIndex].subject_raters.map((rater, index) => (
                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{rater.firstName}</td>
                                        <td>{rater.lastName}</td>
                                        <td>{rater.email}</td>
                                        <td>{rater?.raterGroup?.name}</td>
                                        <td>                                                        
                                            <Tooltip title="Delete" size='small' className='icon icon-sm icon-primary' onClick={() => removeRater(index)}>
                                                <IconButton>
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                        </td>                                               
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* {formik.touched.raters && formik.errors.raters && (
                    <div className="text-danger">{formik.errors.raters}</div>
                    )} */}
                </div>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handleClose}>Close</button>
            </Modal.Footer>
        </Modal>
    )
}